export default {
  nav: {
    home: 'Home',
    categories: 'Categories',
    articles: 'Articles',
    spreadsheet: 'Spreadsheet',
    shoppingGuide: 'Shopping Guide',
    review: 'Review',
    shipping: 'Shipping',
    coupon: 'Coupon',
    language: 'Language',
  },
  footer: {
    about: 'About AllChinaBuy Spreadsheet',
    links: 'Quick Links',
    legal: 'Legal',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
    disclaimer: 'Disclaimer',
    copyright: 'AllChinaBuy Spreadsheet. All rights reserved.',
    description: 'An independent informational resource to help buyers research products, sellers, shipping and QC before ordering.',
  },
  common: {
    readMore: 'Read More',
    explore: 'Explore',
    buyNow: 'Buy It Now',
    continueToMain: 'Continue to the Main Website',
    search: 'Search',
    breadcrumbHome: 'Home',
    close: 'Close',
    open: 'Open',
  },
};